import { useState } from 'react';
import { RATING_ENDPOINT } from '../utils/MockAPI';

export const useRecipeRating = (recipeId: string, userId: string, onRatingComplete?: () => void) => {
  const [ratingOpen, setRatingOpen] = useState(false);
  const [rating, setRating] = useState<number | null>(null);

  const handleRatingSubmit = async () => {
    const finalRating = rating || 1; // Use 1 if no rating selected

    try {
      await fetch(RATING_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          recipeId: recipeId,
          userId: userId,
          rating: finalRating
        })
      });
      // Ignore response as per requirements - just continue as current
    } catch (error) {
      console.error('Error submitting rating:', error);
      // Continue anyway - don't block user flow
    }

    setRatingOpen(false);
    setRating(null); // Reset rating for next use
    if (onRatingComplete) {
      onRatingComplete();
    }
  };

  const openRatingDialog = () => {
    setRatingOpen(true);
  };

  const closeRatingDialog = () => {
    setRatingOpen(false);
    setRating(null);
  };

  return {
    ratingOpen,
    rating,
    setRating,
    handleRatingSubmit,
    openRatingDialog,
    closeRatingDialog
  };
};